import React from "react"
import { useAuth } from "../../hooks/useAuth"
import { useWelcomeStore } from "../../stores/welcomeStore"
import { useTranslation } from "react-i18next"

const Header = () => {
  const { logout } = useAuth()
  const { study } = useWelcomeStore()
  const { t } = useTranslation()

  return (
    <nav className="flex-no-wrap relative flex w-full items-cente shadow-dark-mild dark:bg-store-50 lg:flex-wrap lg:justify-start">
      <div className="flex w-full flex-wrap items-center mx-auto bg-cortexx-50 pt-4 pb-2">
        <div className="flex items-center justify-start ml-1 md:ml-8">
          <div
            className="flex items-center lg:basis-auto"
            id="navbarSupportedContent1"
            data-twe-collapse-item
          >
            <a
              className="flex items-center text-neutral-900 hover:text-neutral-900 focus:text-neutral-900 dark:text-neutral-500 dark:hover:text-neutral-400 dark:focus:text-neutral-400 lg:mb-0 lg:mt-0 bg-cortexx-50 rounded-xl px-6"
              href="/"
            >
              <img
                src={
                  study
                    ? study?.administrative_information.logo_url
                    : "/images/vector-logo.svg"
                }
                style={{ height: "30px" }}
                alt="main logo"
                loading="lazy"
              />
            </a>
          </div>
        </div>
        <div className="flex flex-1 items-end justify-end mr-1 md:mr-8">
          <button
            className="px-6 py-3 bg-cortexx-100 text-cortexx-550 rounded-xl flex-row flex items-center justify-center"
            onClick={logout}
          >
            <img
              src={"/images/logout.svg"}
              style={{ height: "20px" }}
              alt="logout"
              loading="lazy"
            />
            <span className="font-semibold ml-2 md:mr-4">
              {t("header.logout")}
            </span>
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Header
